module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Edit my details")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.customer.first_name ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.first_name),
      expression: "customer.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.customer.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formError && typeof _vm.formError.first_name !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.first_name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    class: [_vm.customer.last_name ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.last_name),
      expression: "customer.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.customer.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formError && typeof _vm.formError.last_name !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.last_name))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: [_vm.customer.phone ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.phone),
      expression: "customer.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.customer.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formError && typeof _vm.formError.phone !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.phone))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    class: [_vm.customer.email ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.email),
      expression: "customer.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.customer.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formError && typeof _vm.formError.email !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.email))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    class: [_vm.customer.address ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.address),
      expression: "customer.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.customer.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formError && typeof _vm.formError.address !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.address))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: [_vm.customer.postcode ? 'show-label' : '', 'form-group']
  }, [_c('label', [_vm._v("Postcode")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.postcode),
      expression: "customer.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.customer.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "postcode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.formError && typeof _vm.formError.postcode !== 'undefined') ? _c('h6', {
    staticClass: "text-danger small"
  }, [_vm._v(_vm._s(_vm.formError.postcode))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b-btn', {
    staticClass: "pull-left",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editProfile($event)
      }
    }
  }, [_vm._v("Update Details")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bea628da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/my-details.vue
// module id = 564
// module chunks = 1